/**
 * Sport detection — returns a canonical sport name (matching SPORTS in lib/sports.js)
 * or null. The public site uses a path prefix: `travelsports.info/basketball`,
 * `/soccer`, `/flag-football`, etc. (Legacy subdomain detection kept as a fallback.)
 *
 * Slugs are lowercase, whitespace replaced with hyphens: "ice-hockey".
 */
import { SPORTS } from "@/lib/sports";

const SLUG_TO_SPORT = Object.fromEntries(
    SPORTS.map((s) => [s.toLowerCase().replace(/\s+/g, "-"), s])
);

export function sportFromSlug(slug) {
    if (!slug) return null;
    return SLUG_TO_SPORT[String(slug).toLowerCase()] || null;
}

/** True when the given path segment names one of our sports. */
export function isSportSlug(slug) {
    return sportFromSlug(slug) != null;
}

export function sportFromSubdomain() {
    if (typeof window === "undefined") return null;
    const host = window.location.hostname;
    // Skip localhost, IPs, and the preview host — only the *.travelsports.info layout applies.
    if (!host.endsWith("travelsports.info")) return null;
    const parts = host.split(".");
    if (parts.length < 3) return null; // main apex or www — no sport prefix
    const first = parts[0].toLowerCase();
    if (first === "www") return null;
    return SLUG_TO_SPORT[first] || null;
}

export function sportToSlug(sport) {
    return String(sport || "").toLowerCase().replace(/\s+/g, "-");
}
